import { Box, Grid, Typography } from "@mui/material";

interface ReadOnlyLayerRowProps {
  layerNumber?: number | null;
  commodityName?: string | null;
  weight: number;
  percentage: number;
  commodityColor: string;
  bgColor: string;
  isLastInGroup?: boolean;
  isCommodityDisabled?: boolean;
}

export const ReadOnlyLayerRow = ({
  layerNumber,
  commodityName,
  weight,
  percentage,
  commodityColor,
  bgColor,
  isLastInGroup = false,
  isCommodityDisabled = false,
}: ReadOnlyLayerRowProps) => (
  <Grid
    container
    sx={(theme) => ({
      borderBottom: `1px solid ${theme.palette.grey[100]}`,
      p: "10px 0",
      bgcolor: bgColor,
      position: "relative",
    })}
  >
    <Box
      sx={{
        position: "absolute",
        bottom: isLastInGroup ? "3px" : 0,
        left: 0,
        height: "3px",
        width: `${percentage}%`,
        bgcolor: commodityColor,
        zIndex: 1,
      }}
    />
    <Grid item md={2} xs={2} sx={{ p: "8px 15px", textAlign: "center" }}>
      <Typography>{layerNumber}</Typography>
    </Grid>
    <Grid item md={4} xs={4} sx={{ p: "8px 15px", textAlign: "center" }}>
      <Typography
        sx={{
          color: isCommodityDisabled ? "error.main" : "inherit",
          fontWeight: isCommodityDisabled ? "bold" : "normal",
        }}
        title={isCommodityDisabled ? "This commodity is disabled" : undefined}
      >
        {commodityName}
      </Typography>
    </Grid>
    <Grid item md={3} xs={3} sx={{ p: "8px 15px", textAlign: "center" }}>
      <Typography sx={{ fontWeight: "bold", color: "primary.main" }}>
        {percentage.toFixed(2)}%
      </Typography>
    </Grid>
    <Grid
      item
      md={3}
      xs={3}
      sx={{ p: "8px 0px 8px 15px", textAlign: "center" }}
    >
      <Typography>{weight}</Typography>
    </Grid>
  </Grid>
);
